/**
 * @fileoverview GET handler for the "/api/calculated_attributes/:id/:app_group_id/engagements" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { apiCalculatedAttributesIdAppGroupIdEngagements } from "./constants";
import type {
  GetApiCalculatedAttributesIdAppGroupIdEngagementsProps,
  GetApiCalculatedAttributesIdAppGroupIdEngagementsResult,
  GetApiCalculatedAttributesIdAppGroupIdEngagementsResultErrors,
} from "./types";
import { isGetApiCalculatedAttributesIdAppGroupIdEngagementsResult } from "./validators";

// propagateFetchRequestError is off because the usage report shows its own error with a retry.
// Left at its default, a failure would also open the global error modal.
export const getApiCalculatedAttributesIdAppGroupIdEngagements = reactQueryFetcherAdapter(
  apiCalculatedAttributesIdAppGroupIdEngagements,
  createGetFetcherFunctionWithShadowError<GetApiCalculatedAttributesIdAppGroupIdEngagementsResultErrors>()(
    (
      signal: AbortSignal,
      { id, appGroupId }: GetApiCalculatedAttributesIdAppGroupIdEngagementsProps
    ): Promise<GetApiCalculatedAttributesIdAppGroupIdEngagementsResult> => {
      return fetch(
        `/api/calculated_attributes/${id}/${appGroupId}/engagements`,
        "GET",
        {},
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),
  isGetApiCalculatedAttributesIdAppGroupIdEngagementsResult
);
